module.exports = __webpack_public_path__ + "media/images/Groupe 127-438f8f85df56293415c63ce3a9d2cde7.svg";